import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import htmlParser from 'utils/html/htmlParser';
import StyledContainer from '../StyledContainerComponent';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
};

function IntroSection({ title, description }) {
  return (
    <Root>
      <DescriptionSection>
        {title && <DescriptionHeader>{title}</DescriptionHeader>}
        <DescriptionText>{htmlParser(description)}</DescriptionText>
      </DescriptionSection>
    </Root>
  );
}

IntroSection.propTypes = propTypes;

export default IntroSection;

const Root = styled(StyledContainer)`
  ${mediaQueries.fromAndAbove.tablet`
    ${flexbox({
      justifyContent: 'space-between',
      alignItems: 'center',
    })}
  `}

  ${mediaQueries.fromAndBelow.tablet`
    ${flexbox({
      flexDirection: 'column',
    })}
  `}
`;

const DescriptionSection = styled.div`
  width: 100%;

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
  `}
`;

const DescriptionHeader = styled.h1`
  font-family: ${({ theme }) => theme.fonts.displaySubtle};
  font-size: 56px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text.templates.header};

  ${mediaQueries.fromAndBelow.tablet`
    font-size: 45px;
    text-align: center;
  `}
`;

const DescriptionText = styled.div`
  margin: 30px 0 0;
  overflow: auto;

  ${mediaQueries.fromAndBelow.tablet`
    margin: 15px 0 0;
    text-align: justify;
  `}
`;
